import {connect} from "react-redux";

import {setQuotes} from "../../../actions/roomsFunctions";
import Analytics from "../../../analytics";
import {
  changeSqftFeaturesPopup,
  setSqftFromFeature,
  setSqftMeasureUnit,
  setSquareFeet
} from "../../../actions/sqftFunctions";
import {setMaterialsPageSubSteps} from "../../../actions/selectionFunctions";
import {MEASURE_UNITS, SQFT_POST_MESSAGE_ACTIONS} from "../constants";
import {getCurrentLayout} from "../../appLayout";
import {
  changeCartItemQuantity,
  changeSelectionInfoQuantity,
  setCameFromPage,
  toggleSelectionFeatureInfo
} from "../../../actions/actionFunctions";
import {toggleShowManualCalculation} from "../../../actions/sqftManualCalculationFunctions";
import {clearAllMenusEvents} from "../components/canvas/core/workspace/workspaceEvents";
import {prepareSQFTData, prepareSQFTDataCore} from "../components/canvas/core/workspace/workspaceDataMapper";
import {useCloseSQFTCalc} from "./useCloseSQFTCalc";
import {saveSQFTDataToQuote} from "../helpers/sqftQuotesHelper";

const WithAddToQuote = (props) => {
  const {activeQuoteIndex} = props;
  const {children} = props;
  const {closeSQFTCalc} = useCloseSQFTCalc();

  const handleAddToQuoteClick = async () => {
    props.changeSqftFeaturesPopup({
      opened: true,
      sqftPassedData: null,
    })
    // //update slabs features just in case they wasn't changed
    // sqftShapeIntersectionsManager.updateShapesIntersections();
    // sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
    // //sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
    // sqftShapeIntersectionsManager.updateSlabImagesFeature();

    // Data without images
    const coreData = prepareSQFTDataCore();
    // This will trigger rebuiltQuotesList
    await saveSQFTDataToQuote(coreData);
    clearAllMenusEvents();
    setDataToQt(coreData, true);
  };

  const setDataToQt = (data, stayOnSqft = false) => {
    if (data) {
      Analytics.sendDataEnteredEvent("square-foot-calc-data-entered");
      //this.props.setSqftMeasureUnit(data.measureUnit);
      const sqftPassedData = Object.assign({}, data, {
        canvasImage: "",
        sqFtSlabImage: "",
        sqFtSlabCalcImage:"",
        sqftApplianceImages: "",
        images3D: ""
      });
      console.log("sqft passedData", sqftPassedData);
      let isLocationNotUsesPopup = false; //always use new popup
        // (
        //   window.location.href.includes("quotekitchenandbath")
        //   //|| window.location.href.includes("quotekandb")
        //   //|| window.location.href.includes("quotesflooring")
        //   //|| window.location.href.includes("localhost")
        // )
        // && !window.location.href.includes("use_sqft_popup=1");

      if (isLocationNotUsesPopup || !props.useSqftCartPopup) {
        setEdgesQuantity(data);
        setRadiusQuantity(data);
        setBacksplashesQuantity(data);
        setCountertopsQuantity(data);
        stayOnSqft = false;
      } else {
        props.changeSqftFeaturesPopup({
          opened: true,
          sqftPassedData,
        })
      }

      // this.addSQFTCanvasImageToDocuments(data); // not used anymore! we keep sqFtCalcImage in the quote

      // we already saving data on handleAddToQuoteClick
      // // set backup data
      // if (!isSqftPassedDataEmpty(data)) {
      //   updateActiveQuoteWithSQFTData(data);
      // }

      // set squareFeet
      props.setSquareFeet(data.squareFeet); // param needed to be set to call confirm popup
      // set quoting tool sub steps (only if minimum 2 items added)
      props.setMaterialsPageSubSteps({
        edges: data.edges && data.edges.length > 1 ? data.edges : [],
        backsplashes: data.backsplashes && data.backsplashes.length > 1 ? data.backsplashes : [],
      });
    }

    if (!stayOnSqft) {
      closeSQFTCalc();
    }

    saveSQFTHistory();
  };

  // const saveSQFTData = (data) => {
  //   const {quotes, activeQuoteIndex} = store.getState().quotesState;
  //   const newQuotes = [...quotes.map((quote, qIndex) => {
  //     if (qIndex === activeQuoteIndex) {
  //       quote.sqFtCalcData = Object.assign({}, data)
  //     }
  //     return quote
  //   })];
  //
  //   setQuotes(newQuotes);
  // };

  const setEdgesQuantity = (data) => {
    const dataEdges = data.edges;
    const edgesIdsObject = {};
    dataEdges.forEach((edge) => { // here we need to check all added edges with the same it and plus their length
      const edgeLength = data.measureUnit === MEASURE_UNITS.Metric ? edge.length : Math.ceil(edge.length);
      const edgeId = +edge.id;
      edgesIdsObject[edgeId] = edgesIdsObject[edgeId] ? edgesIdsObject[edgeId] + edgeLength : edgeLength;
    });
    Object.keys(edgesIdsObject).forEach(edgeId => {
      if (data.measureUnit === MEASURE_UNITS.Metric) {
        edgesIdsObject[edgeId] = +(edgesIdsObject[edgeId]).toFixed(2)
      }
      ["center_island_edge", "edge_profile"].forEach(partId => {
        setSubPartQuantity(partId, edgesIdsObject[edgeId], +edgeId)
      })
    })
  };

  const setRadiusQuantity = (data) => {
    const radiusCount = [...data.radii, ...data.angles].length;
    // let quantity = 0;
    // dataRadiuses.forEach(radius => {
    //   quantity += +radius;
    // });
    if (radiusCount) {
      setSubPartQuantity("radius", radiusCount)
    }
  };

  const setBacksplashesQuantity = (data) => {
    const dataBacksplashes = data.backsplashes;
    let quantity = 0;
    dataBacksplashes.forEach(backsplash => {
      quantity += backsplash.length;
    });
    if (quantity) {
      const backsplashLength = data.measureUnit === MEASURE_UNITS.Metric ? quantity : Math.ceil(quantity);
      setSubPartQuantity("backsplash", backsplashLength)
    }
  };

  const setCountertopsQuantity = (data) => {
    const layout = getCurrentLayout();
    if (data.manualCalculate && data.squareFeet) { // manual calculate
      setSubPartQuantity("countertop", data.squareFeet);
      setSubPartQuantity("center_island_countertop", data.squareFeet);
    } else {
      let countertopSquareFeet = 0;
      let centerIslandCountertopSquareFeet = 0;
      data.countertops.forEach(shape => {
        if (shape.squareFeet) { // countertop & center_island_countertop
          (shape.partId === "countertop")
            ? countertopSquareFeet += shape.squareFeet
            : centerIslandCountertopSquareFeet += shape.squareFeet;
        }
      });
      if (layout.qtCategories) {
        const countertopIsAdded = countertopIsAddedToQtCategory("countertop");
        const centerIslandCountertopIsAdded = countertopIsAddedToQtCategory("center_island_countertop");
        if (countertopIsAdded && centerIslandCountertopIsAdded) { // both
          setSubPartQuantity("countertop", countertopSquareFeet);
          setSubPartQuantity("center_island_countertop", centerIslandCountertopSquareFeet);
        } else if (countertopIsAdded && !centerIslandCountertopIsAdded) { // only countertop is added to QTCategories
          setSubPartQuantity("countertop", data.squareFeet);
        } else if (!countertopIsAdded && centerIslandCountertopIsAdded) {
          setSubPartQuantity("center_island_countertop", data.squareFeet);
        }
      } else {
        setSubPartQuantity("countertop", countertopSquareFeet);
        setSubPartQuantity("center_island_countertop", centerIslandCountertopSquareFeet);
      }
    }
  };

  const countertopIsAddedToQtCategory = (partId) => {
    let countertopExist = false;
    const layout = getCurrentLayout();
    layout.qtCategories.forEach(qtCategory => {
      const subParts = qtCategory.subParts;
      const neededSubPart = subParts.find(subPart => subPart.part.partId === partId);
      if (neededSubPart) {
        countertopExist = true;
      }
    });
    return countertopExist
  };

  const setSubPartQuantity = (partId, quantity, dbFeatureId = null) => {
    /*** if dbFeatureId is passed - we need to set to the Feature quantity, not the feature group! ***/
    const layout = getCurrentLayout();
    // 1) update cart items quantity
    const cartItem = props.cartItems.find(cartItem => {
      return (dbFeatureId
        ? cartItem.cartFeature.dbFeature.id === dbFeatureId
        : cartItem.partId === partId) && cartItem.currentQuote === activeQuoteIndex;
    });
    if (cartItem) {
      props.changeCartItemQuantity(cartItem, quantity);
    }
    // 2) update feature info (current) quantity
    const activeFeature = props.selectionFeatureInfo;
    const updateCurrentFeature = dbFeatureId
      ? activeFeature && activeFeature.dbFeature.id === dbFeatureId
      : activeFeature && activeFeature.partId === partId
    if (updateCurrentFeature) {
      props.changeSelectionInfoQuantity(quantity)
    }
    // 3) update not current quantities
    if (layout.qtCategories) {
      layout.qtCategories.forEach(qtCategory => {
        setFeatureGroupSqftQuantity(qtCategory.subParts, partId, quantity, dbFeatureId)
      })
    } else {
      layout.getFeatures().forEach(parentItem => {
        setFeatureGroupSqftQuantity(parentItem.subParts(), partId, quantity, dbFeatureId)
      })
    }
  };

  const setSqftQuantityToSubPartFinal = (dbFeatureId, neededSubPart, quantity) => {
    if (dbFeatureId) {
      const navItems = neededSubPart.part.navigationSubItems();
      const neededFeature = navItems.find(navItem => navItem.part.dbFeature.id === dbFeatureId);
      if (neededFeature) {
        if (!neededFeature.part.sqftQuantity) {
          neededFeature.part.sqftQuantity = {};
        }
        neededFeature.part.sqftQuantity[activeQuoteIndex] = quantity
      } else {
        // console.log("feature not found, what should we do?");
      }
    } else {
      if (!neededSubPart.part.sqftQuantity) {
        neededSubPart.part.sqftQuantity = {};
      }
      neededSubPart.part.sqftQuantity[activeQuoteIndex] = quantity
    }
  };

  const setFeatureGroupSqftQuantity = (subParts, partId, quantity, dbFeatureId) => {
    const neededSubPart = subParts.find(subPart => subPart.part.partId === partId);
    if (neededSubPart) {
      if (!neededSubPart.part.allFeaturesReceived && neededSubPart.part.partId.includes("edge")) {
        //todo sqftReact
        //this.checkIfAllFeaturesReceived(neededSubPart, "", () => {
          setSqftQuantityToSubPartFinal(dbFeatureId, neededSubPart, quantity)
        //})
      } else {
        setSqftQuantityToSubPartFinal(dbFeatureId, neededSubPart, quantity)
      }
    }
  };

  // const closeSQFTCalc = (payload) => {
  //   sendPostMessageToSqft(SQFT_POST_MESSAGE_ACTIONS.stopRender);
  //   clearAllMenusEvents();
  //   setSqftFromFeature(null);
  //   Analytics.sendClickEvent('sqft-close');
  //   if (payload && payload.measureUnit) {
  //     props.setSqftMeasureUnit(payload.measureUnit);
  //   }
  //   const leaveSqft = () => {
  //     const redirectToPage = cameFromPage && cameFromPage !== "sqft" ? cameFromPage : "materials"
  //     closeSQFTTool(redirectToPage, changeWizardStepRoute);
  //     if (isObject(cameFromPage) && cameFromPage.partId) {
  //       props.toggleSelectionFeatureInfo(cameFromPage);
  //     }
  //     props.setCameFromPage("sqft");
  //   };
  //   if (isFirefox()) {
  //     setTimeout(() => {
  //       leaveSqft();
  //     }, 0)
  //   } else {
  //     leaveSqft();
  //   }
  // };

  const sendPostMessageToSqft = () => {
    // if (this.iframeElement && this.iframeElement.contentWindow) {
    //   this.iframeElement.contentWindow.postMessage({action, payload}, window.location.href);
    // }
  };
  // const resetData() {
  //   closeSQFTCalc();
  //   sendPostMessageToSqft(SQFT_POST_MESSAGE_ACTIONS.resetHistory);
  // }
  const saveSQFTHistory = () => {
    sendPostMessageToSqft(SQFT_POST_MESSAGE_ACTIONS.saveHistory);
  };

  return children(handleAddToQuoteClick, prepareSQFTData);
};

const mapStateToProps = (store) => ({
  measureUnit: store.sqftState.measureUnit,
  quotes: store.quotesState.quotes,
  qtActiveCategory: store.qtState.qtActiveCategory,
  activeRoomType: store.sqftMenuState.activeRoomType,
  cartItems: store.cartState.cartItems,
  selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  sqftVisited: store.sqftState.sqftFeaturesPopup.visited,
  isSlabToolVisited: store.sqftSlabState.isSlabToolVisited,
  useSqftCartPopup: store.sqftState.sqftFeaturesPopup.enabled,
  cameFromPage: store.cartState.cameFromPage
});

const mapDispatchToProps = {
  setQuotes,
  setSquareFeet,
  setMaterialsPageSubSteps,
  changeSqftFeaturesPopup,
  toggleSelectionFeatureInfo,
  setCameFromPage,
  changeCartItemQuantity,
  changeSelectionInfoQuantity,
  setSqftMeasureUnit,
  toggleShowManualCalculation,
  setSqftFromFeature,
};


export default connect(mapStateToProps, mapDispatchToProps)(WithAddToQuote);
